import { LegalPage } from '@/features/legal/components/legal-page'

export default function PrivacyPage() {
  return <LegalPage documentKey="privacy" />
}
